var _defs, _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBehavioralIncidents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.12 91.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#11ccea;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45.56,
    cy: 45.56,
    r: 45.56
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.08,305.25h-1.9l-3.5-.52A26.51,26.51,0,0,1,247,284.29c-.33-1.57-.53-3.17-.79-4.76v-2.38c.19-1.24.34-2.48.58-3.71a26.65,26.65,0,1,1,31.93,31C277.19,304.8,275.63,305,274.08,305.25ZM273,300.32c11.63.2,21.83-9.61,21.89-21.77a21.9,21.9,0,1,0-43.79.24C251.3,290.68,261.29,300.52,273,300.32Z",
    transform: "translate(-226.18 -233.08)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M269.83,273.34c0-2.38,0-4.76,0-7.14a2.11,2.11,0,0,1,1.82-2.4,7.27,7.27,0,0,1,2.9.09,2.11,2.11,0,0,1,1.65,2.3q0,7.26,0,14.52a2.07,2.07,0,0,1-1.64,2.3,8.17,8.17,0,0,1-3.23,0,2,2,0,0,1-1.51-2.14C269.85,278.34,269.83,275.84,269.83,273.34Z",
    transform: "translate(-226.18 -233.08)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.17,290.16a3.16,3.16,0,0,1-6.32,0,3.16,3.16,0,1,1,6.32,0Z",
    transform: "translate(-226.18 -233.08)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehavioralIncidents);
export default __webpack_public_path__ + "static/media/behavioral_incidents.d31e5672e97c7c79479435f771f7c1a7.svg";
export { ForwardRef as ReactComponent };